import { render, staticRenderFns } from "./elementsType.vue?vue&type=template&id=db1b264a"
import script from "./elementsType.ts?vue&type=script&lang=js&external"
export * from "./elementsType.ts?vue&type=script&lang=js&external"
import style0 from "./elementsType.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports